import { transformTimeStamp } from './transformTimeStamp';

/**
 * Retrieve the data source for a link given the item and the plugin that resolved it
 */
export var getDataSource = function getDataSource(item, plugin) {
  var _ref, _item$meta$source, _item$meta, _plugin$meta;
  return (_ref = (_item$meta$source = (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.source) !== null && _item$meta$source !== void 0 ? _item$meta$source : plugin === null || plugin === void 0 || (_plugin$meta = plugin.meta) === null || _plugin$meta === void 0 ? void 0 : _plugin$meta.source) !== null && _ref !== void 0 ? _ref : 'unknown';
};
export function getScreenReaderText(items, selectedIndex, intl) {
  if (items.length && selectedIndex > -1) {
    var _items$selectedIndex = items[selectedIndex],
      name = _items$selectedIndex.name,
      container = _items$selectedIndex.container,
      lastUpdatedDate = _items$selectedIndex.lastUpdatedDate,
      lastViewedDate = _items$selectedIndex.lastViewedDate;
    var date = transformTimeStamp(intl, lastViewedDate, lastUpdatedDate);
    return [name, container, date].filter(Boolean).join(', ');
  }
}